import { useState } from "react";
import { useLanguage } from "../../i18n/LanguageContext";

export default function PracticeHomePage({
  startRandomPractice,
  startNewSmartPracticeRound,
  openSubjectPractice,
  goBack,
  practiceMode,
  activePracticeSummary,
  styles,
}) {
  const { t } = useLanguage();

  const hasActivePractice =
    Boolean(
      activePracticeSummary
    );

  const completedQuestions =
    activePracticeSummary
      ?.completedQuestions || 0;

  const totalQuestions =
    activePracticeSummary
      ?.totalQuestions || 10;

  const progressPercent =
    totalQuestions > 0
      ? Math.round(
          (
            completedQuestions /
            totalQuestions
          ) * 100
        )
      : 0;

  const [
    showNewRoundConfirm,
    setShowNewRoundConfirm,
  ] = useState(false);

  return (
    <div style={styles.card}>
      {/* =====================================================
          HEADER
      ===================================================== */}

      <div style={styles.topBar}>
        <div>
          <div
            style={{
              fontSize: "13px",
              fontWeight: "800",
              color: "#64748b",
              letterSpacing: "0.08em",
              marginBottom: "8px",
            }}
          >
            {t("practice.center")}
          </div>

          <h2
            style={{
              ...styles.sectionTitle,
              marginBottom: "8px",
            }}
          >
            {t("practice.readinessTitle")}
          </h2>

          <div
            style={{
              color: "#64748b",
              fontSize: "16px",
              lineHeight: "1.6",
              maxWidth: "720px",
            }}
          >
            {t("practice.readinessDesc")}
          </div>
        </div>

        <button
          style={styles.secondaryButton}
          onClick={goBack}
        >
          {t("practice.back")}
        </button>
      </div>


      {/* =====================================================
          PRACTICE MODE CARDS
      ===================================================== */}

      <div
        style={{
          marginTop: "32px",

          display: "grid",

          gridTemplateColumns:
            "repeat(auto-fit, minmax(300px, 1fr))",

          gap: "22px",
        }}
      >
        {/* ===================================================
            SMART PRACTICE
        =================================================== */}

        <div
          style={{
            border:
              "1px solid #c7d2fe",

            borderRadius: "20px",

            padding: "28px",

            background:
              "linear-gradient(145deg, #f8faff 0%, #eef4ff 100%)",

            display: "flex",
            flexDirection: "column",

            minHeight: "400px",
          }}
        >
          {/* Icon + badge */}

          <div
            style={{
              display: "flex",

              justifyContent:
                "space-between",

              alignItems:
                "flex-start",

              gap: "16px",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",

                borderRadius:
                  "15px",

                backgroundColor:
                  "#dbeafe",

                display: "flex",

                alignItems:
                  "center",

                justifyContent:
                  "center",

                fontSize: "25px",
              }}
            >
              ✨
            </div>

            <div
              style={{
                padding:
                  "6px 11px",

                borderRadius:
                  "999px",

                backgroundColor:
                  "#dbeafe",

                color:
                  "#1d4ed8",

                fontSize:
                  "11px",

                fontWeight:
                  "800",

                letterSpacing:
                  "0.06em",
              }}
            >
              {t("practice.recommended")}
            </div>
          </div>


          {/* Title */}

          <h3
            style={{
              margin:
                "22px 0 8px",

              fontSize: "24px",

              color: "#172033",
            }}
          >
            {t("practice.smartPractice")}
          </h3>


          {/* Description */}

          <p
            style={{
              margin:
                "0 0 22px",

              color: "#64748b",

              lineHeight: "1.6",
            }}
          >
            {t("practice.smartPracticeDesc")}
          </p>


          {/* Features */}

          <div
            style={{
              display: "grid",

              gap: "11px",

              marginBottom:
                "28px",

              color: "#334155",

              fontSize: "15px",
            }}
          >
            <div>
              ✓ {t("practice.tenQuestionsPerRound")}
            </div>

            <div>
              ✓ {t("practice.focusesWeakAreas")}
            </div>

            <div>
              ✓ {t("practice.prioritizesReview")}
            </div>

            <div>
              ✓ {t("practice.adjustsDifficulty")}
            </div>
          </div>

          {hasActivePractice && (
            <div
              style={{
                marginBottom: "20px",
                padding: "16px",
                borderRadius: "14px",
                backgroundColor:
                  "rgba(255, 255, 255, 0.8)",
                border:
                  "1px solid #dbeafe",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent:
                    "space-between",
                  alignItems: "center",
                  marginBottom: "9px",
                }}
              >
                <strong>
                  {t("practice.currentRound")}
                </strong>

                <span
                  style={{
                    color: "#64748b",
                    fontSize: "14px",
                  }}
                >
                  {completedQuestions} /{" "}
                  {totalQuestions}
                </span>
              </div>

              <div
                style={{
                  height: "8px",
                  backgroundColor:
                    "#e2e8f0",
                  borderRadius:
                    "999px",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width:
                      `${progressPercent}%`,

                    height: "100%",

                    backgroundColor:
                      "#2563eb",

                    borderRadius:
                      "999px",

                    transition:
                      "width 0.25s ease",
                  }}
                />
              </div>

              <div
                style={{
                  marginTop: "9px",
                  color: "#64748b",
                  fontSize: "13px",
                }}
              >
                {t("practice.unfinishedRound")}
              </div>
            </div>
          )}


          {/* Button */}

          <div
            style={{
              marginTop: "auto",
            }}
          >
            <button
              style={{
                ...styles.primaryButton,

                width: "100%",

                justifyContent:
                  "center",

                padding:
                  "14px 18px",
              }}

              onClick={
                startRandomPractice
              }
            >
              {hasActivePractice
                ? t("practice.continueSmartPractice")
                : t("practice.startSmartPractice")}
            </button>
            
            {hasActivePractice && (
              <button
                onClick={() =>
                  setShowNewRoundConfirm(true)
                }
                style={{
                  width: "100%",
                  marginTop: "8px",
                  padding: "11px 14px",
                  border: "none",
                  backgroundColor:
                    "transparent",
                  color: "#64748b",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
              >
                {t("practice.startNewRound")}
              </button>
            )}
          </div>
        </div>


        {/* ===================================================
            PRACTICE BY SUBJECT
        =================================================== */}

        <div
          style={{
            border:
              "1px solid #e2e8f0",

            borderRadius: "20px",

            padding: "28px",

            backgroundColor:
              "#ffffff",

            display: "flex",

            flexDirection:
              "column",

            minHeight: "400px",
          }}
        >
          {/* Icon */}

          <div
            style={{
              width: "52px",
              height: "52px",

              borderRadius:
                "15px",

              backgroundColor:
                "#f1f5f9",

              display: "flex",

              alignItems:
                "center",

              justifyContent:
                "center",

              fontSize: "25px",
            }}
          >
            📚
          </div>


          {/* Title */}

          <h3
            style={{
              margin:
                "22px 0 8px",

              fontSize: "24px",

              color: "#172033",
            }}
          >
            {t("practice.practiceBySubject")}
          </h3>


          {/* Description */}

          <p
            style={{
              margin:
                "0 0 22px",

              color: "#64748b",

              lineHeight: "1.6",
            }}
          >
            {t("practice.practiceBySubjectDesc")}
          </p>


          {/* Features */}

          <div
            style={{
              display: "grid",

              gap: "11px",

              marginBottom:
                "28px",

              color: "#334155",

              fontSize: "15px",
            }}
          >
            <div>
              ✓ {t("practice.reviewAfterClass")}
            </div>

            <div>
              ✓ {t("practice.prepareQuizzesExams")}
            </div>

            <div>
              ✓ {t("practice.targetWeakSubject")}
            </div>

            <div>
              ✓ {t("practice.practiceIndividualTopics")}
            </div>
          </div>


          {/* Button */}

          <div
            style={{
              marginTop: "auto",
            }}
          >
            <button
              style={{
                ...styles.secondaryButton,

                width: "100%",

                justifyContent:
                  "center",

                padding:
                  "14px 18px",
              }}

              onClick={
                openSubjectPractice
              }
            >
              {t("practice.chooseSubject")}
            </button>
          </div>
        </div>
      </div>


      {/* =====================================================
          HOW SMART PRACTICE WORKS
      ===================================================== */}

      <div
        style={{
          marginTop: "26px",

          padding:
            "22px 24px",

          borderRadius:
            "16px",

          backgroundColor:
            "#f8fafc",

          border:
            "1px solid #e2e8f0",
        }}
      >
        <div
          style={{
            display: "flex",

            gap: "15px",

            alignItems:
              "flex-start",
          }}
        >
          <div
            style={{
              fontSize: "21px",
            }}
          >
            💡
          </div>

          <div>
            <div
              style={{
                fontWeight:
                  "800",

                fontSize:
                  "16px",

                color:
                  "#172033",

                marginBottom:
                  "6px",
              }}
            >
              {t("practice.howSmartPracticeWorks")}
            </div>

            <div
              style={{
                color:
                  "#64748b",

                lineHeight:
                  "1.6",

                fontSize:
                  "14px",
              }}
            >
              {t("practice.howSmartPracticeWorksDesc")}
            </div>
          </div>
        </div>
      </div>

      {showNewRoundConfirm && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor:
              "rgba(15, 23, 42, 0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            zIndex: 9999,
          }}
          onClick={() =>
            setShowNewRoundConfirm(false)
          }
        >
          <div
            style={{
              width: "100%",
              maxWidth: "440px",
              backgroundColor: "#ffffff",
              borderRadius: "20px",
              padding: "28px",
              boxShadow:
                "0 20px 60px rgba(15, 23, 42, 0.22)",
            }}
            onClick={(event) =>
              event.stopPropagation()
            }
          >
            <div
              style={{
                fontSize: "36px",
                marginBottom: "14px",
              }}
            >
              ⚠️
            </div>

            <h3
              style={{
                margin: "0 0 10px",
                fontSize: "22px",
                color: "#172033",
              }}
            >
              {t("practice.startNewRoundTitle")}
            </h3>

            <p
              style={{
                margin: 0,
                color: "#64748b",
                lineHeight: "1.6",
                fontSize: "15px",
              }}
            >
              {t("practice.startNewRoundWarning")}
            </p>

            <div
              style={{
                marginTop: "24px",
                display: "flex",
                gap: "12px",
                justifyContent: "flex-end",
                flexWrap: "wrap",
              }}
            >
              <button
                style={styles.secondaryButton}
                onClick={() => {
                  setShowNewRoundConfirm(false);

                  startRandomPractice();
                }}
              >
                {t("practice.continueCurrentRound")}
              </button>

              <button
                style={styles.primaryButton}
                onClick={() => {
                  setShowNewRoundConfirm(false);

                  startNewSmartPracticeRound();
                }}
              >
                {t("practice.confirmStartNewRound")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}